import { Injectable } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { ModalService } from '@app/core/modal.service';

import { FindAndReplaceModalComponent as ModalComponent } from './find-and-replace-modal.component';

import { cloneDeep } from 'lodash';

@Injectable({ providedIn: 'root' })
export class FindAndReplaceModalService {
  constructor(private modalService: ModalService) {}

  open(properties: { editor: any; textToSearch?: string }, options?: NgbModalOptions) {
    const newOptions = cloneDeep(options || {});
    newOptions.backdropClass = (newOptions.backdropClass || '').split(/\s+/).concat('backdrop--color-none').join(' ');
    newOptions.windowClass = (newOptions.windowClass || '').split(/\s+/).join(' ');
    newOptions.beforeDismiss = () => {
      properties.editor.commands.setSearchTerm('');
      properties.editor.commands.setReplaceTerm('');

      properties.editor.commands.resetIndex();

      return true;
    };
    return this.modalService.open(ModalComponent, properties, newOptions);
  }
}
